__turbopack_context__.v({
  "bannerContainer": "p5Poya_bannerContainer",
  "bannerContainerContent": "p5Poya_bannerContainerContent",
  "bannerContainerImage": "p5Poya_bannerContainerImage",
  "postCardContainer": "p5Poya_postCardContainer",
  "read_more_button": "p5Poya_read_more_button",
});
